import EditProgramStudent from "../../../../modules/academyProgramPersonalInfo/ui/programStudent/EditProgramStudent";
import { WrapperModalUsers } from "./styled";

export const ModalEditStudentProgram = ({
  openModal,
  setOpenModal,
  programStudentId,
  onSuccess,
}: {
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
  programStudentId: number;
  onSuccess?: () => void;
}) => {
  return (
    <WrapperModalUsers
      title="Editar estudiante en el programa"
      open={openModal}
      width="360px"
      destroyOnClose
      onClose={() => setOpenModal(false)}
    >
      <EditProgramStudent
        programStudentId={+programStudentId}
        setOpenModal={setOpenModal}
        onSuccess={onSuccess}
      />
    </WrapperModalUsers>
  );
};
